import { NoteReview, RemoteStateNoteReviewInterface } from './interfaces';

export const transformRemoteStateReview = (
  rsReview: RemoteStateNoteReviewInterface,
): NoteReview => {
  return Object.fromEntries(
    Object.entries({
      noteId: rsReview?.noteId,
      overallReview: rsReview?.overallReview,
      poorReviewReasons: rsReview?.specificPoorReviews,
      textResponse: rsReview?.textResponse,
    }).filter(([_, value]) => value),
  );
};
